import { htmlNew, htmlTagged, htmlOnInput } from '../fun-js-lib/html'
import { maxNLinesOnMainPageWorkDescription } from '../pdfPrinter/draw-page/lower/workDescription'
import { emptyCanvas, maxNLinesOnOtherPage as maxNLinesOnOtherPage } from '../pdfPrinter/draw-page/otherPageImg'
import { nLinesInWorkDescription } from '../pdfPrinter/draw-page/texts'
import { tooLongWorkDescriptionHint } from './hint'

export function initValidateWorkDescription () {
  let input = inputElement()
  htmlOnInput(input, scheduleValidate)

  validate()
}

export const isWorkDescriptionFilledIncorrectly = () =>
  !isValidOrEmpty()

export function isWorkDescriptionInputElementEmpty () {
  return nLinesInInputElement() === 0
}

let callbackIdThatShouldBeLaunched = 0

/**
 * Schedule validation to prevent multiple consecutive
 * validations while user is typing
 */
function scheduleValidate () {
  const callbackId = Math.random()
  callbackIdThatShouldBeLaunched = callbackId
  setTimeout(() => {
    if (callbackIdThatShouldBeLaunched === callbackId) {
      validate()
    }
  }, 250)
}

function validate () {
  let valid = isValidOrEmpty()
  container().classList.toggle('is-invalid', !valid)
  if (valid) {
    unsetErrorHint()
  } else {
    setErrorHint()
  }
}

const isValidOrEmpty = () =>
  isValid() || jsonOfInputElement() === ''

function isValid () {
  const length = jsonOfInputElement().length
  const maxJsonLength = 100000
  const nLines = nLinesInInputElement()
  const maxNLines = maxNLinesOnMainPageWorkDescription + maxNLinesOnOtherPage
  return nLines <= maxNLines && length <= maxJsonLength
}

function nLinesInInputElement () {
  let emptyContext = emptyCanvas.getContext('2d')
  return nLinesInWorkDescription(emptyContext, jsonOfInputElement())
}

function setErrorHint () {
  unsetErrorHint()
  let h6 = htmlNew('h6')
  h6.classList.add('text-center')
  let small = htmlNew('small')
  small.classList.add('text-danger')
  small.classList.add('h5')
  small.innerHTML = tooLongWorkDescriptionHint
  h6.appendChild(small)
  container().prepend(h6)
}

function unsetErrorHint () {
  htmlTagged(container(), 'h6')
    .forEach(h6 => h6.remove())
}

function inputElement () {
  return htmlTagged(container(), 'input')
    .filter(input => input.classList.contains('quill-hidden-input'))[0]
}

function jsonOfInputElement () {
  return inputElement().value
}

function container () {
  return document.getElementById('workDescriptionContainer')
}